import "core-js/modules/es6.array.find";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.regexp.split";
import { match } from "@reach/router/lib/utils";
import stripPrefix from "./strip-prefix";
import normalizePagePath from "./normalize-page-path";

var trimPathname = function trimPathname(rawPathname) {
  var pathname = decodeURIComponent(rawPathname); // Remove the pathPrefix from the pathname.

  var trimmedPathname = stripPrefix(pathname, __BASE_PATH__); // Remove any hashfragment

  if (trimmedPathname.split("#").length > 1) {
    trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
  } // Remove search query


  if (trimmedPathname.split("?").length > 1) {
    trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
  }

  return trimmedPathname;
};

var PathFinder =
/*#__PURE__*/
function () {
  function PathFinder(matchPaths) {
    this.matchPaths = matchPaths;
    this.pathCache = new Map();
  }

  var _proto = PathFinder.prototype;

  _proto.findMatchPath = function findMatchPath(trimmedPathname) {
    for (var _iterator = this.matchPaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var _ref3 = _ref2;
      var matchPath = _ref3.matchPath,
          path = _ref3.path;

      if (match(matchPath, trimmedPathname)) {
        return path;
      }
    }

    return null;
  } // Given a raw URL path, returns the cleaned version of it (trim off
  // `#` and query params), or if it matches an entry in
  // `match-paths.json`, its matched path is returned
  //
  // E.g `/foo?bar=far` => `/foo`
  //
  // Or if `match-paths.json` contains `{ "/foo*": "/page1", ...}`, then
  // `/foo?bar=far` => `/page1`
  ;

  _proto.find = function find(rawPathname) {
    var trimmedPathname = trimPathname(rawPathname);

    if (this.pathCache.has(trimmedPathname)) {
      return this.pathCache.get(trimmedPathname);
    }

    var foundPath = this.findMatchPath(trimmedPathname);

    if (!foundPath) {
      if (trimmedPathname === "/index.html") {
        foundPath = "/";
      } else {
        foundPath = trimmedPathname;
      }
    }

    foundPath = normalizePagePath(foundPath);
    this.pathCache.set(trimmedPathname, foundPath);
    return foundPath;
  };

  return PathFinder;
}();

export default PathFinder;